import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';


function Infox({ id, height }) {
  const [elementId, setElementId] = useState(`infox_${id}`);

  useEffect(() => {
    if (!process.env.BROWSER_RUNTIME) return;

    /* eslint-disable */
    (function(w, d, n, s, t) {
      w[n] = w[n] || [];
      w[n].push(function() {
        window['INFOX' + id].renderTo(elementId);
        /**
         * убираем id элемента после инициализации для того, чтобы работали
         * несколько этих партнерок на одной странице
         */
        setElementId(null);
      });
      t = d.getElementsByTagName("script")[0];
      s = d.createElement("script");
      s.type = "text/javascript";
      s.src = `//rb.infox.sg/infox/${id}`;
      s.async = true;
      t.parentNode.insertBefore(s, t);
  })(window, window.document, `infoxContextAsyncCallbacks${id}`);
    /* eslint-enable */
  }, [elementId, id]);

  return (
    <div id={elementId} style={{ minHeight: height }} />
  );
}

Infox.propTypes = {
  id: PropTypes.number.isRequired,
  height: PropTypes.number,
};

export default Infox;
